import React from 'react';
import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { UploadStatus } from '@/types/upload';
import { UPLOAD_STATUS_CLASSES } from '@/config/upload';
import { isImportInProgress } from '@/utils/upload';

/** An upload's status; a spinner shows that a queued or running import will still change. */
const UploadStatusBadge: React.FC<{ status: UploadStatus }> = ({ status }) => {
  const { t } = useTranslation();
  return (
    <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[11px] whitespace-nowrap ${UPLOAD_STATUS_CLASSES[status]}`}>
      {isImportInProgress(status) && <Loader2 size={11} className="animate-spin" />}
      {t(`uploads.status_${status}`)}
    </span>
  );
};

export default UploadStatusBadge;
